import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { getUrlWithAddedQueryParameters } from './index';

const FALLBACK_TODO_APP_LINK = 'https://to-do.microsoft.com';

export default function getTodoModuleUrl(): string {
    const userConfig = getUserConfiguration();
    const userOptions = userConfig.UserOptions;
    const upn = userConfig.SessionSettings?.UserPrincipalName;

    let url = FALLBACK_TODO_APP_LINK;

    if (userOptions?.ReactOptinSettings?.TasksRedirectUrl) {
        url = userOptions.ReactOptinSettings.TasksRedirectUrl;

        if (upn) {
            url = getUrlWithAddedQueryParameters(userOptions.ReactOptinSettings.TasksRedirectUrl, {
                auth_upn: upn,
            });
        }
    }

    return url;
}
